import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useId } from "react";

// Compact select for listing/table filters. Form selects should keep using CustomSelect.
export default function CustomSelect2({
  values,
  onChange,
  data = [],
  label,
  error,
  disabled,
  valueName,
  labelName,
  IconComponent,
  className,
  sx,
}) {
  const id = useId();
  const labelId = `${id}-label`;

  return (
    <FormControl variant="outlined" fullWidth size="small" error={Boolean(error)} className={className}>
      {label && <InputLabel id={labelId} sx={{ fontSize: "14px" }}>{label}</InputLabel>}
      <Select
        className="me-2 d-flex"
        size="small"
        labelId={label ? labelId : undefined}
        value={values}
        label={label}
        disabled={disabled}
        IconComponent={IconComponent}
        onChange={onChange}
        sx={{
          height: 40,
          borderRadius: "6px",
          backgroundColor: "#fff",
          fontSize: "14px",
          color: "#172630",
          "& .MuiSelect-select": { py: "8px", px: "14px" },
          "& .MuiInputLabel-root": { fontSize: "14px" },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e3e6ea" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#000" },
          ...sx,
        }}
      >
        {data.map((option, index) => {
          const isObject = option !== null && typeof option === "object";
          const optionValue = isObject
            ? (valueName ? option[valueName] : option.value ?? option.id)
            : option;
          const optionLabel = isObject
            ? (labelName ? option[labelName] : option.label ?? option.name ?? optionValue)
            : option;
          return <MenuItem key={optionValue ?? index} value={optionValue} sx={{ fontSize: "14px" }}>{optionLabel}</MenuItem>;
        })}
      </Select>
      {error && <FormHelperText>{Array.isArray(error) ? error.join(" ") : error}</FormHelperText>}
    </FormControl>
  );
}
